import { http } from './http'

export const orderList = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/payment/alipay/order-list',
        method: 'post',
        body: data,
    })